export function resolveDashboardUrl(currentHref: string, explicitDashboardUrl?: string): string | null {
  const fallback = explicitDashboardUrl?.trim();
  if (fallback) {
    return new URL(fallback, currentHref).toString();
  }

  const current = new URL(currentHref);

  if (current.hostname === 'localhost' || current.hostname === '127.0.0.1') {
    const localDashboard = new URL(current.origin);
    localDashboard.port = '5174';
    return localDashboard.toString();
  }

  const hostLabels = current.hostname.split('.');
  const portalLabelIndex = hostLabels.findIndex(label => label === 'myaccount' || label === 'portal');
  if (portalLabelIndex === 0 || portalLabelIndex === 1) {
    const isConnectPlane = hostLabels.slice(-2).join('.') === 'connectplane.com';
    hostLabels.splice(0, portalLabelIndex + 1, isConnectPlane ? 'app' : 'dashboard');
    if (isConnectPlane && hostLabels[1] === 'prod') {
      hostLabels.splice(1, 1);
    }
    const derivedDashboard = new URL(current.origin);
    derivedDashboard.hostname = hostLabels.join('.');
    return derivedDashboard.toString();
  }

  return null;
}
